import React from "react";
import PresignedPage from "./PresignedPage";
import V2RouteShell from "../V2RouteShell";

function PresignedV2(props) {
  return (
    <V2RouteShell>
      <PresignedPage {...props} />
    </V2RouteShell>
  );
}

export default PresignedV2;
